var componentRequireContext = require.context(
  "components",
  true,
  /front\/common\/FloatingPromotionBanner|front\/search_page\/*|youtube\/*/
);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

import '../src/preview_buttons'
